import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { siteRequestHeaders } from '../../lib/siteRequestHeaders';
import { ReceiptText } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { GameBetDetails } from './GameBetDetails';
import { isBetId, normalizeBetId } from '../chat/betCommands';

const PUBLIC_GAME = { demo: true, config: null };

export const PublicBetDetails = ({ publicId, game = PUBLIC_GAME, onClose, lookup = false, returnFocus, onPlay }) => {
  const [round, setRound] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const closing = useRef(false);
  const valid = isBetId(publicId);
  const close = () => { closing.current = true; onClose(); };
  const restore = (event) => {
    if (!returnFocus) return;
    event.preventDefault();
    if (closing.current) returnFocus();
  };
  useEffect(() => {
    const controller = new AbortController();
    setRound(null); setError('');
    if (!valid) { setError('Invalid bet ID. Copy the full Bet ID from your bet history.'); return () => controller.abort(); }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/bets/${lookup ? 'lookup/' : ''}${encodeURIComponent(normalizeBetId(publicId))}`, { signal: controller.signal, timeout: 15000, headers: siteRequestHeaders() })
      .then(({ data }) => { if (!controller.signal.aborted) setRound(data); })
      .catch((failure) => { if (!controller.signal.aborted) setError(failure.response?.status === 404 ? 'This bet is unavailable. Only completed account bets can be shared.' : 'Unable to load this bet. Please try again.'); });
    return () => controller.abort();
  }, [publicId, attempt, lookup, valid]);
  if (round) return <GameBetDetails round={round} game={game} onClose={close} onCloseAutoFocus={restore} onPlay={onPlay} />;
  return <Dialog open onOpenChange={(open) => { if (!open) close(); }}>
    <DialogContent className="keno-dialog" data-testid="public-bet-loading-dialog" onCloseAutoFocus={restore}>
      <DialogHeader><DialogTitle><ReceiptText className="inline mr-2" size={20} />Bet</DialogTitle><DialogDescription className="sr-only">Public bet receipt</DialogDescription></DialogHeader>
      <p role={error ? 'alert' : 'status'} data-testid="public-bet-load-status">{error || 'Loading bet…'}</p>
      {error && valid && <Button className="keno-secondary" data-testid="public-bet-retry" onClick={() => setAttempt((value) => value + 1)}>Try again</Button>}
    </DialogContent>
  </Dialog>;
};
